import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { Client } from 'src/app/client/client';
import { Website } from 'src/app/client/website';
import { GoogleKeywordService } from 'src/app/software-services/search-engine-optimization/keywords/google-keyword.service';
import { KeywordMetrics } from 'src/app/software-services/search-engine-optimization/keywords/keyword-metrics';
import { KeywordMetricsRequest } from 'src/app/software-services/search-engine-optimization/keywords/keyword-metrics-request';
import { SoftwareService } from 'src/app/software-services/software-service';
import { ChartData } from 'src/app/widgets/matrix-tools-chart/chart-data';

@Injectable({
  providedIn: 'root'
})
export class ServiceDashboardService {
  constructor(private googleKeywords: GoogleKeywordService) {}

  private _client: Client = new Client();
  public get client() {
    return this._client;
  }
  public set client(client: Client) {
    this._client = client;
  }

  private _website: Website;
  public get website() {
    return this._website;
  }
  public set website(website: Website) {
    debugger;//jebjebjebjeb
    // Set required Website Data
    this._website = website;

    //************
    // CHART.JS DATA
    // Google Keywords (SEO)
    // Change Log (Commit History)
    // Contract (Client DB)
    //************
    // Google Keywords
    if (!this._website.topTenAllTimeKeywords) {
      let requestOrig = new KeywordMetricsRequest();
      requestOrig.domain = this._website.domain;

      // Google Keywords - Top Ten - All Time
      this.googleKeywords.getKeywords(requestOrig).subscribe((topTenAllTimeKeywords) => {
        this._website.topTenAllTimeKeywords = topTenAllTimeKeywords;//jeb still needed?

        // Google Keywords - Top Ten - Last Month        
        this.googleKeywords.getKeywords(requestOrig).subscribe((topTenLastMonthKeywords) => {
          this._website.topTenLastMonthKeywords = topTenLastMonthKeywords;//jeb still needed?

          // Google Keywords - Target Keywords - Last Month
          requestOrig.keywords = this._website.keywords;
          this.googleKeywords.getKeywords(requestOrig).subscribe((targetedLastMonthKeywords) => {
            this._website.targetedLastMonthKeywords = targetedLastMonthKeywords;//jeb still needed?

            // SEO Chart Data!
            let seoChartRequests = [];
            let uniqueKeys = [];
            for (let keyword of this._website.keywords) {
              let request = new KeywordMetricsRequest();
              request.domain = this._website.domain;
              request.keywords = [];
              //jeb need to pick the best format? or we could TODO: add BOTH, and after requests, compare the latest entry of both to see which is lower, and then remove the other from unique keys?
              let localKeyword = this.client.location.split(',')[0] + ' ' + keyword;
              //let localKeyword = keyword + ' ' + this.client.location.split(',')[0];
              request.keywords.push(localKeyword);
              uniqueKeys.push(localKeyword);
              
              // Requests = One year of Historical Keyword Data (by month) + Current month (by week)
              // One year (by month)
              for (let i = -12; i < 0; i++) {
                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth() + i, 1);
                request.endDate = new Date(new Date().getFullYear(), new Date().getMonth() + 1 + i, 1);
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));
              }

              // Current month (by week)
              let currentDay = new Date().getDate();
              if (currentDay <= 7) {
                // Add 1 week
                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                request.endDate = new Date();
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));
              } else if (currentDay <= 15) {
                // Add 2 weeks
                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                request.endDate = new Date(new Date().getFullYear(), new Date().getMonth(), 7);
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));

                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 8);
                request.endDate = new Date();
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));
              } else if (currentDay <= 23) {
                // Add 3 weeks
                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                request.endDate = new Date(new Date().getFullYear(), new Date().getMonth(), 7);
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));

                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 8);
                request.endDate = new Date(new Date().getFullYear(), new Date().getMonth(), 15);
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));

                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 16);
                request.endDate = new Date();
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));
              } else {
                // Add 4 weeks
                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
                request.endDate = new Date(new Date().getFullYear(), new Date().getMonth(), 7);
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));

                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 8);
                request.endDate = new Date(new Date().getFullYear(), new Date().getMonth(), 15);
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));

                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 16);
                request.endDate = new Date(new Date().getFullYear(), new Date().getMonth(), 23);
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));

                request.startDate = new Date(new Date().getFullYear(), new Date().getMonth(), 24);
                request.endDate = new Date();
                // Make a copy of the request (and eTag Workaround) so the forkJoin will work correctly
                seoChartRequests.push(this.googleKeywords.getKeywords({ ...request }));
              }
            }

            forkJoin(seoChartRequests).subscribe(keywords => {
              this._website.seoChartData = [];
              var legendColors = ['#8549ba', '#58595b', '#00a950', '#166a8f', '#acc236', '#537bc4', '#f53794', '#f67019', '#4dc9f6', '#f0f', '#ff0', '#0ff', '#0f0', '#f00', '#00f'];
              for (let keyword of uniqueKeys) {
                this._website.seoChartData.push(new ChartData(keyword, legendColors.pop(),
                  keywords.flat()
                    .filter((x: any) => x.keys[0].toLowerCase() === keyword.toLowerCase())
                    .map((keyword: KeywordMetrics) => ({
                      // Plot date-range data based on the EndDate
                      // Workaround: eTag contains the EndDate
                      x: new Date(keyword.eTag).getMonth() === new Date().getMonth()
                        // For the current month, show the exact date (comes in grouped by week)
                        ? keyword.eTag
                        // For past months, show only the month and year (comes in grouped by month)
                        : keyword.eTag.substring(0, 7),
                      y: keyword.position,
                      label: `${keyword.clicks} Google Clicks`
                  }))
                ));
              }
            });
          });
        });
      });
    }

    // Change Log
    if (!this._website.commitHistoryChartData) {
      this._website.commitHistoryChartData = {
        name: 'Change Log',
        color: '#000',
        showLine: false,
        pointStyle: 'triangle',
        points: this._website.commitHistory
          // Remove Duplicates (by month)
          .filter(
            (commit, i, arr) => arr.findIndex(c => new Date(c.commit.author.date).toISOString().substring(0, 7) === new Date(commit.commit.author.date).toISOString().substring(0, 7)) === i
          )
          .map((commit) => {
            return {
              // Month
              x: new Date(commit.commit.author.date).toISOString().substring(0, 7),
              // Commit Count (grouped by month)
              y: this._website.commitHistory
                .filter(c => new Date(c.commit.author.date).toISOString().substring(0, 7) === new Date(commit.commit.author.date).toISOString().substring(0, 7))
                .length,
              // Commit Messages (grouped by month)
              label: this._website.commitHistory
                .filter(c => new Date(c.commit.author.date).toISOString().substring(0, 7) === new Date(commit.commit.author.date).toISOString().substring(0, 7))
                .map(c => { return new Date(c.commit.author.date).toLocaleDateString() + ': ' + c.commit.message })
                .join('\r\n\r\n')
            }
          })
          // Sort by x (month)
          .sort((a, b) => new Date(a.x).getTime() - new Date(b.x).getTime())
      };
    }

    // SEO Service Dates
    if (!this._website.contractDatesChartData) {
      let startYear = new Date(this.client.softwareServiceRenewalDate).getFullYear() - 1;
      let startMonth = new Date(this.client.softwareServiceRenewalDate).getMonth();
      let startDate = new Date(this.client.softwareServiceRenewalDate).getDate();
      let startDay = new Date(startYear, startMonth, startDate);
      this._website.contractDatesChartData = {
        name: 'SEO Service Dates',
        color: '#EEBC1D',//jeb change to green like the vertical line
        showLine: false,
        pointStyle: 'star',
        points: [{
          label: 'SEO Service - Start Date',
          x: startDay.toISOString().substring(0, 7),
          y: 1,
          
        },
        {
          label: 'SEO Service - End Date',
          x: this.client.softwareServiceRenewalDate.toString().substring(0, 7),
          y: 1
        }]
      }
    }
  }

  private _softwareServices: SoftwareService[];
  public get softwareServices() {
    return this._softwareServices;
  }
  public set softwareServices(softwareService: SoftwareService[]) {
    this._softwareServices = softwareService;
  }

  public get changeLogErrors() {
    if (!this.website) {
      return null;
    }

    if (!this.website.commitHistory 
      || !this.website.commitHistory.length) {
      return 'Change Log repository is not configured.';
    }
    
    return null;
  }
}
